import { CanActivateFn } from "@angular/router";
import { map, tap } from "rxjs";
import { environment } from "src/environments/environment";
import { UserService } from "../services/user.service";
import { inject } from "@angular/core";
import { SnackBarService } from "src/app/shared/services/snack-bar.service";
import { Constants } from "src/app/shared/constants/constants";

export function productionGuard(): CanActivateFn {
    return () => !environment.production;
}

export function pipingDataReadViewGuard(): CanActivateFn {
    return userInRoles(
          [Constants.pipingRevisionWriter, Constants.pipingReleaseWriter,
            Constants.pipingDictionaryWriter, Constants.pipingDictionaryReader,
            Constants.admin, Constants.scanner]);
}

export function pipingDictionaryEditViewGuard(): CanActivateFn {
    return userInRoles([Constants.pipingDictionaryWriter, Constants.admin, Constants.scanner]);
}

export function pipingRevisionEditViewGuard(): CanActivateFn {
    return userInRoles([Constants.pipingRevisionWriter, Constants.admin, Constants.scanner]);
}

export function pipingRevisionReadViewGuard(): CanActivateFn {
    return userInRole(Constants.pipingRevisionReader);
}

export function pipingValvesBulkUploadGuard(): CanActivateFn {
    return userInRoles([Constants.valvesBulkUploadReader, Constants.valvesBulkUploadWriter]);
}

// Backend `Roles.PipingAdmin` maps to the same "Admin" role as `Constants.admin`.
export function userManagementAdministrationGuard(): CanActivateFn {
    return userInRole(Constants.admin);
}

export function buPdfBulkUploadGuard(): CanActivateFn {
    return userInRoles([Constants.admin, Constants.pipingSasbuAdmin, Constants.pipingNmaAdmin]);
}

export function userInRole(role: string): CanActivateFn {
    return () => {
        const userService: UserService = inject(UserService);
        const snackBarService: SnackBarService = inject(SnackBarService);
        return userService.roles$.pipe(
            map(userRoles => userRoles.filter(userRole => role === userRole).length > 0),
            tap(isAuthorized => {if(!isAuthorized)snackBarService.showError('You are not authorized to access this resource.')}),
        )
    }
}

export function userInRoles(inputRoles: string[]): CanActivateFn {
    return () => {
        const userService: UserService = inject(UserService);
        const snackBarService: SnackBarService = inject(SnackBarService);
        return userService.roles$.pipe(
            map(userRoles => {
                return userRoles.some(userRole => inputRoles.includes(userRole))
            }),
            tap(isAuthorized => {
                if (!isAuthorized) {
                    snackBarService.showError('You are not authorized to access this resource.')
                }
            }),
        )
    }
}
